export default __webpack_public_path__ + "static/media/4.220a6cd1.svg";